import { supabase } from './supabase';

export async function deleteUserAccount(): Promise<{ success: boolean; error?: string }> {
  try {
    // Get current user
    const { data: { user }, error: userError } = await supabase.auth.getUser();
    
    if (userError) throw userError;
    if (!user) throw new Error('No authenticated user');

    // Call the deletion procedure
    const { error } = await supabase
      .rpc('delete_user_account', {
        user_id: user.id
      });

    if (error) throw error;

    // Sign out after successful deletion
    await supabase.auth.signOut();

    return { success: true };
  } catch (error: any) {
    console.error('Error deleting account:', error);
    return {
      success: false,
      error: error.message || 'Failed to delete account'
    };
  }
}